import Link from "next/link";
import React from "react";
import Image from "next/image";
import { Post } from "data/types";
import clsx from "clsx";
import styles from "./PostGrid.module.css";

export interface PostGridProps {
  posts: Post[];
  limited?: boolean;
}

export const PostGrid: React.FC<PostGridProps> = ({ posts, limited }) => {
  return (
    <ul
      className={clsx(
        "flex flex-wrap justify-around gap-2 overflow-hidden [--row-height:160px] after:block after:grow-5 sm:[--row-height:208px] md:[--row-height:240px]",
        limited &&
          `max-h-[calc(var(--row-height)*3+2*0.5rem)] ${styles.smallScreenFix} sm:max-h-[calc(var(--row-height)*2+0.5rem)] xl:max-h-(--row-height)`,
      )}
    >
      {posts.map((p) => {
        const ar =
          Math.round((p.images[0].width / p.images[0].height) * 10) / 10;
        const arX = -((ar - 1) / 4);

        return (
          <li
            className={
              "bg-primary-1 dark:bg-primary-3 relative h-40 grow overflow-hidden rounded-sm sm:h-52 md:h-60"
            }
            style={{
              minWidth: `calc(var(--row-height) * ${ar * (0.8 + arX)})`,
              flexGrow: ar,
            }}
            title={p.title}
            key={p.id}
          >
            <Link href={`/images/${p.id}/${p.slug}`} scroll={true}>
              <div className="relative h-full min-w-full">
                <Image
                  className="object-cover"
                  src={p.images[0].urls.thumb}
                  alt={p.title}
                  fill
                />
                <div className="absolute right-0 bottom-1 flex max-w-full flex-wrap justify-end gap-1 px-1 text-xs dark:text-slate-900">
                  {["available", "unreleased"].includes(p.altvStatus) && (
                    <div className="rounded-lg bg-gray-100/90 px-1.5">AltV</div>
                  )}
                  {p.images.length > 1 && (
                    <div className="truncate rounded-lg bg-gray-100/90 px-1.5">
                      +{p.images.length - 1} version
                      {p.images.length === 2 ? "" : "s"}
                    </div>
                  )}
                </div>
              </div>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
